import React from 'react'
import moment from 'moment'
import {
  defaultValues,
  getRisksArray,
  validateStateDetails
} from '../../../../../accs-gov-enrolments/helpers'
import DefaultForm from '../../../../../ui/forms/default-form'
import ACCSForm from '../../../../accs/form'
import { available } from '../../view/helper'

const formValue = 'create_certificate'

const calculateSubmitValues = (values) => {
  let risk = getRisksArray(values)

  const submitValues = { ...values, risk_reasons: risk }

  if (values.evidence && values.evidence.length === 0) delete submitValues.evidence

  if (!validateStateDetails(submitValues.state_details))
    delete submitValues.state_details

  delete submitValues.name

  return submitValues
}

const validate = (values) => {
  const risks = getRisksArray(values)
  const hasStartDate = values.start_date != null
  const hasRisks = risks.length > 0
  let valid = hasRisks && hasStartDate

  const weeksSinceStart = hasStartDate ? moment().diff(moment(values.start_date), 'weeks') : 0
  if (weeksSinceStart > 4) {
    valid = valid && values.evidence && values.evidence.length > 0
  }
  return valid
}

const successMessage = 'ACCS Certificate has been created. It\'s recommended to create a determination while a certificate is active for the child. You can copy this certificate information into a determination form by clicking Action in the top right and selecting \'Copy to Determination\''

const actionForm = ({ child, regHolderId }) => ({ handleSuccess }) => {

  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/children/${child.crn}/accs/submit-certificate`
      }
      name={formValue}
      label='Create Certificate'
      loadingTitle='Submitting ACCS Certificate...'
      calculateSubmitValues={calculateSubmitValues}
      handleSuccess={() =>
        handleSuccess(
          {
            [formValue]: successMessage
          },
          formValue
        )
      }
      formOptions={{ validate, defaultValues: defaultValues(child) }}
      formComponent={(props) => (
        <ACCSForm
          {...props}
          isDetermination={false}
          required={false}
          child={child}
        />
      )}
    />
  )
}

export const createCertificate = ({
  child,
  available_actions,
  regHolderId,
  refresh_accs_gov_enrolments
}) => {
  return available({ available_actions })
    ? {
      label: 'New Certificate',
      value: 'create_certificate',
      actionForm: actionForm({ child, regHolderId }),
      onCompletePreserveAction: true,
      onComplete: () => refresh_accs_gov_enrolments(child.accs_path)
    } : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/create-certificate/index.js